import TB from '@tiger/bridge';
import { Button } from 'antd';
import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Card, { CardButtonWrap } from 'components/Card';
import ScrollTop from 'components/ScrollTop';
import store from 'modules/Transfer/store';
import resultIcon from 'static/images/icons/complete.png';
import APP from 'stores/APP';
import security from 'stores/security';
import { printf } from 'utils/i18n';
import withTransferForm, { PageIdEnum, TransferFormProps } from '../../../withTransferForm';
import { PARTIAL_ACATS_BASE_PATH } from '../helper';
import './style.scss';

const Result: FC<TransferFormProps> = observer(({ clearStorageData }) => {
    const location = useLocation();
    const locationState = location.state as { haveUploadedFiles: boolean } | null;
    const navigate = useNavigate();
    const haveUploadedFiles = locationState?.haveUploadedFiles;
    // app直接关闭当前页面, app外部跳转到个人中心首页
    const handleClick = () => {
        if (APP.isTiger) {
            TB.quit();
        } else {
            navigate('/profile', {
                replace: true
            });
        }
    };

    useEffect(() => {
        store.setShowProgressBar(false);

        return () => {
            // 进入完成页面表示流程结束, 需要把表单中的缓存信息清掉, 同时重置 brokerMode
            clearStorageData();
            store.clearBrokerMode();
        };
    }, [clearStorageData]);

    return (
        <Card form className="transfer-result-root">
            <ScrollTop />
            <img className="icon" src={resultIcon} alt="icon" />
            <div className="result-title">
                <h3>{__('Your position transfer request has been received')}</h3>
                {haveUploadedFiles ? null : (
                    <p
                        className="result-sub-title"
                        dangerouslySetInnerHTML={{
                            __html: printf(
                                security.isIRAAccount
                                    ? __(
                                          "To prevent any delays in processing, don't forget to upload your most recent brokerage statement and photo ID on the Transfer History page. You can also email us at %s !"
                                      )
                                    : __(
                                          "To prevent any delays in processing, don't forget to upload your most recent brokerage statement on the Transfer History page. You can also email us at %s !"
                                      ),
                                `<a href="mailto:support@tradeup.com">support@tradeup.com</a>`
                            )
                        }}
                    />
                )}
            </div>
            <section className="result-content">
                <div className="content-item">
                    <div className="item-title">{__('Application Withdrawal')}</div>
                    <p>{__('You can withdraw the application before we start processing your request.')}</p>
                </div>
                <div className="content-item">
                    <div className="item-title">{__('Processing Time')}</div>
                    <p>{__('ACATS transfers are completed in 5-7 business days once initiated.')}</p>
                </div>
                <div className="content-item">
                    <div className="item-title">{__('Transfer Fee')}</div>
                    <p>
                        {__(
                            'TradeUP does not charge any fees for incoming ACATS transfers. Please confirm with the delivering firm if they will charge a fee for this transfer.'
                        )}
                    </p>
                </div>
            </section>
            <CardButtonWrap>
                <Button size="large" type="primary" onClick={handleClick}>
                    {__('OK')}
                </Button>
            </CardButtonWrap>
        </Card>
    );
});

export default withTransferForm({
    id: PageIdEnum.RESULT,
    showProgressBar: false,
    basePath: PARTIAL_ACATS_BASE_PATH
})(Result);
